module.exports = __webpack_public_path__ + "static/media/policy_settings_approval_workflows.d7ab3a15.svg";